import { render, staticRenderFns } from "./u-main-section-basic.vue?vue&type=template&id=262d629c"
import script from "./u-main-section-basic.vue?vue&type=script&lang=js"
export * from "./u-main-section-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports